export default __webpack_public_path__ + "static/media/h-bar-stack.314e3be2.svg";